/**
 * API 运行时配置。
 * 统一读取 window.__BACKEND_GATEWAY__（由 index.tsx 初始化阶段写入）。
 * 有网关 → 绝对路径直连；无网关 → 相对路径 /api（nginx proxy 转发）。
 */

const BUILD_TIME_BACKEND_GATEWAY =
  typeof __BACKEND_GATEWAY__ !== 'undefined' ? __BACKEND_GATEWAY__ : '';

const normalizeGateway = (gateway: string): string => gateway.trim().replace(/\/+$/, '');

let backendGateway = normalizeGateway(
  (typeof window !== 'undefined' ? window.__BACKEND_GATEWAY__ : '') || BUILD_TIME_BACKEND_GATEWAY,
);

/** API 基础路径 */
export let API_BASE_URL: string = backendGateway ? `${backendGateway}/api` : '/api';

/** API origin（HTTP 域名部分），相对路径模式下为空字符串 */
export let API_ORIGIN: string = backendGateway;

/**
 * 应用启动后更新运行环境网关。
 *
 * API_BASE_URL 与 API_ORIGIN 使用 ES 模块实时绑定，已加载的 HTTP、WebSocket
 * 客户端会立即读取到新值，不需要重新加载模块。
 */
export const configureApiGateway = (gateway: string): void => {
  backendGateway = normalizeGateway(gateway);
  API_BASE_URL = backendGateway ? `${backendGateway}/api` : '/api';
  API_ORIGIN = backendGateway;
  if (typeof window !== 'undefined') {
    window.__BACKEND_GATEWAY__ = backendGateway;
  }
};

/**
 * 把后端返回的资源 href 解析成前端可直接访问的最终地址。
 */
export const resolveApiHref = (href: string): string => {
  if (!href) return href;
  if (/^https?:\/\//i.test(href)) return href;
  if (!backendGateway) return href;
  return href.startsWith('/') ? `${backendGateway}${href}` : href;
};
